<template>
  <v-row
      align="center"
      justify="center"
  >
    <v-col
        cols="12"
        sm="8"
        md="6"
        lg="4"
    >
      <v-card class="elevation-12">
        <v-toolbar
            color="primary"
            dark
            flat
        >
          <v-toolbar-title class="text-center">Register your account</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(onSubmit)" autocomplete="no">
            <v-card-text class="pt-6 pb-0">
              <ValidationProvider vid="email" tag="div" rules="required|email" name="Email" v-slot="{ errors }">
                <v-text-field
                    label="Email"
                    outlined
                    name="email"
                    prepend-inner-icon="mdi-account"
                    type="text"
                    :error-messages="errors"
                    v-model="email"
                    :disabled="emailDisabled"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider vid="password" tag="div" rules="required|min:8" name="password" v-slot="{ errors }">
                <v-text-field
                    id="password"
                    outlined
                    label="Password"
                    name="password"
                    prepend-inner-icon="mdi-lock"
                    type="password"
                    :error-messages="errors"
                    v-model="password"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider tag="div" rules="required|password:@password" name="password confirmation" v-slot="{ errors }">
                <v-text-field
                    id="password_confirmation"
                    outlined
                    label="Confirm Password"
                    name="password_confirmation"
                    prepend-inner-icon="mdi-lock"
                    type="password"
                    :error-messages="errors"
                    v-model="passwordConfirmation"
                ></v-text-field>
              </ValidationProvider>
            </v-card-text>
            <v-card-actions>
              <v-btn block :loading="loading" color="primary" type="submit">Register</v-btn>
            </v-card-actions>
          </form>
        </ValidationObserver>
      </v-card>
      <router-link to="/login">
        <p class="mt-4 text-center">&#8592; Back to login</p>
      </router-link>
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src

import {mapActions} from "vuex";
import { ValidationObserver, ValidationProvider, localize } from 'vee-validate';

localize({
  en: {
    fields: {
      password: {
        min: 'Password must be greater than 8 characters',
      }
    }
  }
});

export default {
  name: 'Register',
  title: 'Register',
  props: ['initialEmail','token'],
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    loading: false,
    email: null,
    password: null,
    passwordConfirmation: null,
    emailDisabled: false,
  }),
  methods: {
    ...mapActions({
      register: 'auth/register',
      triggerToast: 'toast/trigger',
    }),
    onSubmit: async function() {
      this.loading = true;
      try {
        await this.register({email: this.email, password: this.password, password_confirmation: this.passwordConfirmation, token: this.token});
        let url = this.$route.query.redirect || '/'
        await this.$router.push(url)
      }
      catch (error)    {
        this.$refs.form.setErrors(error.response.data.errors);
      }
    this.loading = false;
  }
},
  watch: {
    initialEmail: {
      handler: function(value) {
        if(value !== null) {
          this.email = value;
          this.emailDisabled = true;
        }
      },
      immediate: true
    },
  },
}
</script>